import ArcNumber from '@arcxgame/contracts/dist/src/utils/ArcNumber'
import { BigNumber } from 'ethers'
import { Synth } from 'src/services/GraphService'

export function calculateLiquidationPrice(
  collateralAmount: BigNumber,
  debtAmount: BigNumber,
  price: BigNumber,
  synth: Synth,
) {
  if (!synth || debtAmount.isZero() || price.isZero() || collateralAmount.isZero()) {
    return ArcNumber.new(0)
  }

  return debtAmount.mul(synth.collateralRatio).div(collateralAmount)
}
